import { Alert, Box } from '@mui/material'
import { CSSProperties } from 'react'
import { useTranslation } from 'react-i18next'

const NoSessionPage = () => {
  const { t } = useTranslation('common')
  const alertStyle: CSSProperties = {
    margin: '10px auto 0',
    width: '80%',
  }
  return (
    <Box>
      <Alert sx={alertStyle} severity="error">
        {t('auth_error')}
      </Alert>
    </Box>
  )
}

export default NoSessionPage
